/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ created: NonNullable<unknown>, updated: NonNullable<unknown>, tasks: NonNullable<unknown> }} Matches_RanInputs */

const cs_matches_ran = /** @type {(inputs: Matches_RanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Párování dokončeno — ${i?.created} nových, ${i?.updated} aktualizovaných, ${i?.tasks} úkolů`)
};

const en_matches_ran = /** @type {(inputs: Matches_RanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Matching finished — ${i?.created} created, ${i?.updated} updated, ${i?.tasks} tasks`)
};

/**
* | output |
* | --- |
* | "Matching finished — {created} created, {updated} updated, {tasks} tasks" |
*
* @param {Matches_RanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_ran = /** @type {((inputs: Matches_RanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_RanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_ran(inputs)
	return cs_matches_ran(inputs)
});